exports.DYNAMIC_CREATIVES_DIMENSION_KEYS = [
    'dimension1',
    'dimension2',
    'dimension3',
    'dimension4',
    'dimension5',
    'dimension6'
];

exports.INNOVID_DYNAMIC_CREATIVE_DIMENSION_INFO = [
    {
        dimension_subtext: 'cta_text',
        label_default: 'CTA Text',
    },
    {
        dimension_subtext: 'offer',
        label_default: 'Offer',
    },
    {
        dimension_subtext: 'model',
        label_default: 'Model',
    },
    {
        dimension_subtext: 'creative',
        label_default: 'Creative',
    },
    {
        dimension_subtext: 'master_name',
        label_default: 'Master Name',
    },
];



// WEBPACK FOOTER //
// ./src/constants/dynamicCreatives.js